<template>
    <div class="pics">
        <van-image fit="cover" @click="previewImage(index)" class="pic" v-for="(img,index) in imgs" :key="index" :src="img"/>
    </div>
</template>
<script>
import { ImagePreview } from 'vant'
export default {
   name: 'CommentPic',
   props: {
       urls:{
           type: Array,
           default: () => {
               return []
           }
       }
   },
   computed: {
       imgs() {
           let imgs = []
           imgs = this.urls.map(item=>{
               item.replace('https://cdn-xcx-qunsou.weiyoubot.cn', 'https://image.xiaoqiandao.com') + '?imageMogr2/crop/500x500/gravity/northwest/thumbnail/300x300';
               return item
           })
           return imgs
       }
   },
   methods: {
       previewImage(index) {
           ImagePreview(this.urls,index)
       }
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}
.pics {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.pic {
    width: rem(150);
    height: rem(150);
    margin-right: rem(16);
    margin-bottom: rem(16);
    border-radius: rem(8);
}
</style>


// WEBPACK FOOTER //
// src/components/CommentPic.vue